import React from "react";
import { CircularProgress } from "@mui/material";

export const CircularProgressCustom = ({ loadingText = "Loading..." }) => {
    return (
        <div className="d-flex flex-column align-items-center mt-4">
            <CircularProgress color="inherit" />
            <>{loadingText}</>
        </div>
    );
};
